import { Component, OnDestroy, OnInit } from '@angular/core';
import { debounceTime, Subscription } from 'rxjs';
import { getAllRoyalMarketLocations } from 'src/app/shared/constants/locations.constant';
import { getAllPriceTypes, PRICE_TYPES } from 'src/app/shared/constants/market.constant';
import { Location } from 'src/app/shared/models/location.model';
import { PriceType } from 'src/app/shared/models/market.model';
import { FlipperStateService } from '../flipper-state.service';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { SectionComponent } from 'src/app/shared/components/section/section.component';
import { SubsectionComponent } from 'src/app/shared/components/subsection/subsection.component';
import { SectionSubstitleComponent } from 'src/app/shared/components/section-subtitle/section-subtitle.component';
import { JsonReaderService } from 'src/app/services/json-reader/json-reader.service';
import { ItemImageComponent } from 'src/app/shared/components/item-image/item-image.component';
import { LoadingBarService } from 'src/app/services/loading-bar/loading-bar.service';

@Component({
  selector: 'app-flipper-settings',
  imports: [
    CommonModule,
    MatIconModule,
    NgxMatSelectSearchModule,
    SectionComponent,
    SectionSubstitleComponent,
    SubsectionComponent,
    MatInputModule,
    MatButtonModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatSelectModule,
    ItemImageComponent,
  ],
  templateUrl: './flipper-settings.component.html',
  styleUrl: './flipper-settings.component.scss',
})
export class FlipperSettingsComponent implements OnInit, OnDestroy {
  royalMarketLocations: Location[] = getAllRoyalMarketLocations();
  priceTypes: PriceType[] = getAllPriceTypes();

  subscriptions: Subscription[] = [];

  get isAverageSelected(): boolean {
    return this.flipperStateService.flipperFormGroup.controls.resourcesPriceType.value === PRICE_TYPES.average;
  }

  // MARK: CONSTRUCTOR
  constructor(
    public flipperStateService: FlipperStateService,
    public jsonReaderService: JsonReaderService,
    public loadingBarService: LoadingBarService
  ) {}

  // MARK: LIFECYCLE HOOKS
  ngOnInit(): void {
    this.jsonReaderService.ensureLoaded();

    this.subscriptions.push(
      this.flipperStateService.availableAmountsFormRecord.valueChanges.pipe(debounceTime(500)).subscribe((value) => {
        this.flipperStateService.upgradeResources().forEach((resource) => {
          resource.availableAmount = value[resource.item.uniqueName] ?? null;
        });
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe);
  }
}
